/*
 *
 * Footer
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 25-Nov-2024
 */

import Footer from './Footer'

export default Footer
